export const techButtonColors: string[] = [
  '#8F002D',
  '#049DD9',
  '#1a002d',
  '#260043',
  '#400070',
  '#6404BB',
  '#1C2B1A',
  '#662400',
  '#404040',
  '#006663',
  '#9C3E00',
  '#0597F2',
  '#970FF2',
  '#000000',
  '#3345A6',
  '#593434',
  '#A62C21',
  '#002c04',
  '#2C6CBF',
  '#595334',
  '#593C39',
  '#849400',
  '#4D8CC4',
  '#c11919',
  '#2E4F41',
  '#720672',
  '#8000E0',
  '#086ef4',
  '#9A0A42',
  '#180909'
];
